(function() {
  const isProduct = document.body.classList.contains('single-hfic_product');

  // Swiper gallery
  if (typeof Swiper !== 'undefined') {
    const thumbsEl = document.querySelector('.hero-thumbs');
    const mainEl = document.querySelector('.hero-main');
    if (thumbsEl && mainEl) {
      const thumbs = new Swiper(thumbsEl, {
        spaceBetween: 20,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
        navigation: {
          nextEl: '.hero-thumbs-next',
          prevEl: '.hero-thumbs-prev',
        },
      });

      new Swiper(mainEl, {
        spaceBetween: 10,
        thumbs: {
          swiper: thumbs,
        },
      });
    }
  }

  // Nutrition facts toggle
  const nfToggle = document.querySelector('[data-nf-toggle]');
  if (nfToggle) {
    const left = nfToggle.getAttribute('data-nf-left');
    const right = nfToggle.getAttribute('data-nf-right');
    const track = nfToggle.querySelector('.toggle-track');

    const setState = (state) => {
      nfToggle.setAttribute('data-nf-state', state);
      document.querySelectorAll('[data-nf-panel]').forEach(panel => {
        panel.classList.toggle('is-active', panel.getAttribute('data-nf-panel') === state);
      });
      if (track) {
        // Mark pressed when on the right (serving) so thumb moves right; default left (100g) is false.
        track.setAttribute('aria-pressed', state === right ? 'true' : 'false');
      }
    };

    // Default to left (100g) on load.
    setState(left);

    nfToggle.addEventListener('click', (e) => {
      const btn = e.target.closest('.toggle-track');
      if (!btn) return;
      const current = nfToggle.getAttribute('data-nf-state') === right ? right : left;
      const target = current === left ? right : left;
      setState(target);
    });
  }

  // Unit toggle
  const unitToggle = document.querySelector('[data-unit-toggle]');
  if (unitToggle) {
    const track = unitToggle.querySelector('.toggle-track');
    const setUnit = (unit) => {
      unitToggle.setAttribute('data-unit-state', unit);
      document.body.dataset.units = unit;
      if (track) {
        track.setAttribute('aria-pressed', unit === 'imperial' ? 'true' : 'false');
      }
    };

    setUnit(unitToggle.getAttribute('data-unit-state') || 'metric');

    unitToggle.addEventListener('click', (e) => {
      const btn = e.target.closest('.toggle-track');
      if (!btn) return;
      const current = unitToggle.getAttribute('data-unit-state') === 'imperial' ? 'imperial' : 'metric';
      const next = current === 'metric' ? 'imperial' : 'metric';
      setUnit(next);
    });
  }

  // Header search toggle
  const searchTrigger = document.querySelector('.search-trigger');
  const searchForm = document.querySelector('.header-search');
  if (searchTrigger && searchForm) {
    const input = searchForm.querySelector('input[name="s"]');
    const searchIcon = searchTrigger.querySelector('.search-icon');
    const closeIcon = searchTrigger.querySelector('.close-icon');
    const openForm = () => {
      searchForm.classList.add('is-open');
      searchTrigger.setAttribute('aria-expanded', 'true');
      if (searchIcon) searchIcon.style.display = 'none';
      if (closeIcon) closeIcon.style.display = 'block';
      if (input) input.focus();
    };
    const closeForm = () => {
      searchForm.classList.remove('is-open');
      searchTrigger.setAttribute('aria-expanded', 'false');
      if (searchIcon) searchIcon.style.display = 'block';
      if (closeIcon) closeIcon.style.display = 'none';
    };

    searchTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (searchForm.classList.contains('is-open')) {
        closeForm();
      } else {
        openForm();
      }
    });

    document.addEventListener('click', (e) => {
      if (!searchForm.contains(e.target) && !searchTrigger.contains(e.target)) {
        closeForm();
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        closeForm();
      }
    });
  }

  // Load More (AJAX)
  const loadMoreBtn = document.getElementById('load-more-btn');
  if (loadMoreBtn && typeof hfic_ajax !== 'undefined') {
    const grid = document.querySelector('.product-grid');
    const maxPages = parseInt(grid.getAttribute('data-max-pages'), 10);
    const taxonomy = grid.getAttribute('data-taxonomy') || '';
    const term = grid.getAttribute('data-term') || '';

    loadMoreBtn.addEventListener('click', function () {
      const currentPage = parseInt(grid.getAttribute('data-page'), 10);
      const nextPage = currentPage + 1;

      loadMoreBtn.disabled = true;
      loadMoreBtn.textContent = 'Loading…';

      const body = new FormData();
      body.append('action', 'hfic_load_more');
      body.append('nonce', hfic_ajax.nonce);
      body.append('page', nextPage);
      if (taxonomy) body.append('taxonomy', taxonomy);
      if (term) body.append('term', term);

      fetch(hfic_ajax.ajax_url, { method: 'POST', body: body })
        .then(function (res) { return res.json(); })
        .then(function (res) {
          if (res.success) {
            grid.insertAdjacentHTML('beforeend', res.data);
            grid.setAttribute('data-page', nextPage);

            if (nextPage >= maxPages) {
              loadMoreBtn.parentElement.remove();
            } else {
              loadMoreBtn.disabled = false;
              loadMoreBtn.textContent = 'More Products';
            }
          } else {
            loadMoreBtn.parentElement.remove();
          }
        })
        .catch(function () {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = 'More Products';
        });
    });
  }

  // Video modal
  const videoModal   = document.getElementById('video-modal');
  const videoIframe  = document.getElementById('video-modal-iframe');
  const modalClose   = videoModal && videoModal.querySelector('.video-modal__close');
  const modalBackdrop = videoModal && videoModal.querySelector('.video-modal__backdrop');

  if (videoModal && videoIframe) {
    const openModal = (videoId, isVertical) => {
      videoIframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
      videoModal.classList.toggle('video-modal--vertical', !!isVertical);
      videoModal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (modalClose) modalClose.focus();
    };

    const closeModal = () => {
      videoModal.hidden = true;
      videoIframe.src = '';
      videoModal.classList.remove('video-modal--vertical');
      document.body.style.overflow = '';
    };

    document.querySelectorAll('.video-card__trigger').forEach((btn) => {
      btn.addEventListener('click', () => {
        const videoId = btn.getAttribute('data-video-id');
        const isVertical = btn.getAttribute('data-video-vertical') === '1';
        if (videoId) openModal(videoId, isVertical);
      });
    });

    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);

    videoModal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeModal();
    });
  }

  // Language toggle (TranslatePress)
  const langToggle = document.querySelector('[data-lang-toggle]');
  if (langToggle) {
    const track = langToggle.querySelector('.toggle-track');
    const leftCode = langToggle.getAttribute('data-lang-left');
    const rightCode = langToggle.getAttribute('data-lang-right');
    const leftUrl = langToggle.getAttribute('data-lang-left-url');
    const rightUrl = langToggle.getAttribute('data-lang-right-url');

    if (!leftCode || !rightCode) {
      return;
    }

    const setState = (state) => {
      langToggle.setAttribute('data-lang-state', state);
      if (track) {
        track.setAttribute('aria-pressed', state === rightCode ? 'true' : 'false');
      }
    };

    setState(langToggle.getAttribute('data-lang-state') || leftCode);

    langToggle.addEventListener('click', (e) => {
      const btn = e.target.closest('.toggle-track');
      if (!btn) return;
      const current = langToggle.getAttribute('data-lang-state') === rightCode ? rightCode : leftCode;
      const target = current === leftCode ? rightCode : leftCode;
      const targetUrl = target === rightCode ? rightUrl : leftUrl;
      if (targetUrl) {
        window.location.href = targetUrl;
      }
    });
  }

  // Guard against double-clicked (or slow-page) duplicate form submissions across the site —
  // most harmful on the Pardot lead forms, where a repeat click creates a duplicate CRM record.
  // Delegated on document so it always evaluates after a form's own submit-time validation
  // (e.g. the Turnstile/terms gating in the pardot form templates): bubble-phase listeners on
  // document fire last regardless of script load order, since a target's own submit handlers
  // run first as the event bubbles up.
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const submitBtn = form.querySelector('input[type="submit"], button[type="submit"]');
    if (!submitBtn) return;

    if (submitBtn.disabled) {
      // a previous click already sent this form; block the repeat
      e.preventDefault();
      return;
    }

    if (e.defaultPrevented) {
      // an earlier submit handler already blocked this attempt (e.g. bot check/terms not met) —
      // don't lock the button for a submission that isn't actually going through
      return;
    }

    // deferred a tick so the browser's native submission (triggered by this same event)
    // can't be raced by the button becoming disabled first
    setTimeout(() => {
      submitBtn.disabled = true;
      if (submitBtn.tagName === 'INPUT') {
        submitBtn.value = 'Submitting...';
      } else {
        submitBtn.textContent = 'Submitting...';
      }
    }, 0);
  }, false);
})();
